import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {
  @Input() routerLink: string[];
  @Input() forceShow: boolean;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  get shouldShow(): boolean {
    return this.router.url.split('/')[1] !== 'home';
  }

  onBackClick() {
    if (this.routerLink) {
      this.router.navigate(this.routerLink);
    } else {
      const urlArray = this.router.url.split('/');
      urlArray.pop();
      const backOneLevel = urlArray.join('/');
      this.router.navigate([backOneLevel]);
    }
  }
}
